<template>
  <nav>
    <div class="nav-left">
      <router-link to="/azure-ado-projects">Projects</router-link>
      <router-link to="/fetch-json-files">Aegis</router-link>
      <router-link to="/tenant-baseline-options">Tenant Baseline</router-link>

      <!-- Dropdown for App Deploy -->
      <div class="dropdown">
        <router-link to="/storage-tables-list" class="dropdown-link"
          >App Deploy</router-link
        >
        <div class="dropdown-content">
          <router-link to="/pipelines-list">Client Pipelines</router-link>
          <router-link to="/ViewAppList">Client Yaml Files</router-link>
          <router-link to="/storage-tables-list"
            >Client Table Viewer</router-link
          >
          <router-link to="/ClientPipelineSchedules"
            >Client Pipeline Schedules</router-link
          >
        </div>
      </div>

      <!-- New Dropdown for Tenant Management -->
      <div class="dropdown">
        <span class="dropdown-link">Tenant Management</span>
        <div class="dropdown-content">
          <router-link to="/tenant-backup">Tenant Backups</router-link>
          <router-link to="/fetch-json-files"
            >Configuration Comparison</router-link
          >
        </div>
      </div>
    </div>

    <div class="nav-right">
      <!-- Display user photo and name when logged in -->
      <div v-if="userIsLoggedIn && loggedInUser" class="user-info">
        <img
          :src="userPhoto || defaultPhoto"
          alt="Profile Photo"
          class="profile-photo"
        />
        <span
          >Logged in user:
          {{ loggedInUser.displayName || loggedInUser.upn }}</span
        >
      </div>
      <button v-if="userIsLoggedIn" @click="logout" class="logout-button">
        Logout
      </button>
    </div>
  </nav>
</template>

<script>
import { logout } from "@/auth.js";
import { computed } from "vue";
import { useStore } from "vuex";
import defaultPhoto from "@/assets/Default-Profile-Picture.png"; // Import default photo

export default {
  name: "NavBar",
  setup() {
    const store = useStore();
    const userIsLoggedIn = computed(() => store.state.isLoggedIn);
    const loggedInUser = computed(() => store.state.loggedInUser);
    const userPhoto = computed(() => store.state.userPhoto || defaultPhoto);

    return {
      userIsLoggedIn,
      loggedInUser,
      userPhoto,
      logout,
      defaultPhoto,
    };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&family=Roboto:wght@400;500;700&display=swap");

nav {
  display: flex;
  justify-content: space-between;
  background-color: #0e223b;
  padding: 1rem;
  align-items: center;
  font-family: "Roboto", sans-serif;
}

.nav-left {
  display: flex;
  align-items: center;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-info {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  margin-right: 10px;
}

.profile-photo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
  object-fit: cover;
}

nav a,
.dropdown-link {
  color: #fff;
  text-decoration: none;
  margin-right: 1rem;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  padding: 10px;
  transition: color 0.2s;
}

nav a:hover,
.dropdown-link:hover {
  color: #38b35f;
}

.logout-button {
  background-color: #38b35f;
  color: white;
  font-size: 1rem;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
}

.logout-button:hover {
  background-color: #ffffff;
  color: #0e223b;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-link {
  display: inline-block;
  color: #fff;
  text-decoration: none;
  padding: 10px;
  cursor: pointer;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #0e223b;
  min-width: 200px;
  top: 100%;
  left: 0;
  z-index: 1;
  border-top: 2px solid #38b35f;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.dropdown:hover .dropdown-content,
.dropdown-content:hover {
  display: block;
}

.dropdown-content a {
  color: white;
  padding: 10px 16px;
  text-decoration: none;
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  transition: background-color 0.2s;
}

.dropdown-content a:hover {
  background-color: #38b35f;
  color: #fff;
}
</style>
